import { useNavigate } from "react-router";
import styles from "./home.module.css";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <div className={styles["hero-section"]} data-aos="zoom-out-down">
      <h1 className="main-heading">
        Get In
        <br />
       Shape
      </h1>
      <div>
        <button onClick={() => navigate("/contact")}>Start Today</button>
        <button onClick={() => navigate("/about")}>About Me</button>
      </div>
    </div>
  );
};

export default HeroSection;
